import React, { useContext, useState } from 'react';
import { WizardContext } from './hooks/WizardContext';

import PanelHeader from './PanelHeader';
import MobilePage from './MobilePage';
import Icon from '../Common/Icon';

import ActionToolbar from './ActionToolbar';
import AppToolbar from './AppToolbar';
import ConfirmModal from '../Common/ConfirmModal';

import { useHeaderTitle } from './hooks/uiInteractions/useHeaderTitle';
import * as MAP from './styles/MobileAppPanel.styles';

const MobileAppPanel = () => {

  const {
    // UI State & Toggles
    device, orientation, onDeviceChange, onOrientationChange,
    // App State
    activePage, appName, layout,
    // Selection State
    selectedControlId, selectedSectionId,
    // Actions from Hooks
    addSection, handleAddAll, handleRemoveAll, toolbarActions,
    handlePreviewClick, confirmModal,
} = useContext(WizardContext);


  const activePageLayout = (layout && layout[activePage?.id]) || [];
  const headerTitle = useHeaderTitle(appName, layout[activePage?.id], selectedSectionId, selectedControlId);
  
  const isControlOnMobilePanel = activePageLayout.some(section =>
    section.controls.some(control => control.id === selectedControlId)
  );


  return (
    <MAP.PanelWrapper>
      <PanelHeader title={headerTitle}>
        <MAP.IconGroup>
          <MAP.IconButton isActive={device === 'phone'} onClick={() => onDeviceChange('phone')}><Icon name="phone" color="#000000" /></MAP.IconButton>
          <MAP.IconButton isActive={device === 'tablet'} onClick={() => onDeviceChange('tablet')}><Icon name="tablet" color="#000000" /></MAP.IconButton>
          <MAP.IconButton onClick={() => onOrientationChange(orientation === 'portrait' ? 'landscape' : 'portrait')}><Icon name="rotate" color="#000000" /></MAP.IconButton>
          <MAP.IconButton onClick={handlePreviewClick}><Icon name="preview" color="#000000" /></MAP.IconButton>
        </MAP.IconGroup>
      </PanelHeader>

      <MAP.ContentArea>
        <MAP.ToolbarSlot>
          {(!selectedControlId || (!isControlOnMobilePanel)) && (
            <AppToolbar
              onAddSection={() => addSection({ pageId: activePage.id })}
              onAddAll={handleAddAll}
              onRemoveAll={handleRemoveAll}
              sections={activePageLayout.length}
            />
          )}
        </MAP.ToolbarSlot>

        <MAP.DeviceFrameStyled device={device} orientation={orientation}>
          <MAP.DeviceScreen>
            {activePage ? (
              <MobilePage />
            ) : (
              <div>No page selected</div>
            )}
          </MAP.DeviceScreen>
        </MAP.DeviceFrameStyled>
        <MAP.ToolbarSlot>
          {toolbarActions && <ActionToolbar {...toolbarActions} />}
        </MAP.ToolbarSlot>
      </MAP.ContentArea>
      {confirmModal && <ConfirmModal {...confirmModal} />}
    </MAP.PanelWrapper>
  );
};

export default MobileAppPanel;